import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Goal from 'modules/goals/store/models/Goal'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

import GoalRow from '../_GoalRow'

interface BodyProps {
  goalConfig: GoalConfig
  filteredGoals: Goal[]
  showActions?: boolean
}

const Body = ({ goalConfig, filteredGoals, showActions }: BodyProps) => {
  if (!filteredGoals.length) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={13}>
            <Box alignItems="center" paddingY="s24">
              <Text size="300">{i18n.t('surveys.goals.show.table.empty')}</Text>
            </Box>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    )
  }

  return (
    <Table.Body>
      {filteredGoals.map((goal) => (
        <GoalRow
          key={goal.attributes.id}
          goal={goal}
          goalConfig={goalConfig}
          showActions={showActions}
        />
      ))}
    </Table.Body>
  )
}

export default observer(Body)
